import { SpatialDatabase, IBoundingBoxObject } from "@spi/Common/Util";
import { Ray, RayTraceResult } from "@spi/Common/Math";

export class PickingManager {
    private currentColorIndex: number;
    private mapping: { [key: number]: PickableObject };
    private spatialDatabaseList: SpatialDatabaseItem[];

    constructor() {
        this.mapping = {};
        this.spatialDatabaseList = [];
        this.currentColorIndex = 1;
    }

    public mapColor(color: number, obj: PickableObject) {
        this.mapping[color] = obj;
        obj.pickingColor = color;
    }

    public getObject<T>(color: number): T {
        return this.mapping[color] as any as T;
    }

    public mapNext(obj: PickableObject) {
        while (this.mapping[this.currentColorIndex]) {
            this.currentColorIndex++;
        }
        this.mapping[this.currentColorIndex] = obj;
        obj.pickingColor = this.currentColorIndex;
    }

    public registerSpatialDatabase(spatialDatabase: SpatialDatabase<IBoundingBoxObject>, name: string, callback: PickingCallback, priority?: number) {

        this.spatialDatabaseList.push({
            database: spatialDatabase,
            name: name,
            callback: callback,
            priority: priority || 0
        });

        this.spatialDatabaseList.sort((a, b) => {
            return b.priority - a.priority;
        });
    }

    public unregisterSpatialDatabase(spatialDatabase: SpatialDatabase<IBoundingBoxObject>) {

        for (let i = 0; i < this.spatialDatabaseList.length; i++) {
            if (this.spatialDatabaseList[i].database === spatialDatabase) {
                this.spatialDatabaseList.splice(i, 1);
                return;
            }
        }
    }

    public getRayIntersections(ray: Ray): Map<string, SpatialDatabaseHits> {
        let hitMap = new Map<string, SpatialDatabaseHits>();

        for (let spatialDb of this.spatialDatabaseList) {
            let hits = spatialDb.database.rayTrace(ray);
            if (hits && hits.length > 0) {
                hitMap.set(spatialDb.name, {
                    ray: ray,
                    hits: hits,
                    callback: spatialDb.callback
                });
            }
        }

        return hitMap;
    }
}

type PickableObject = {
    pickingColor: number
}

type SpatialDatabaseItem = {
    database: SpatialDatabase<IBoundingBoxObject>,
    name: string,
    callback: PickingCallback,
    priority: number
}

type PickingCallback = (name: string, type: string, hits: RayTraceResult[]) => boolean; 

type SpatialDatabaseHits = {
    ray: Ray,
    hits: RayTraceResult[],
    callback: PickingCallback
}
